// Recordings are stored as bare S3 keys, which every player signs. For a while the web Writing &
// Speaking step stored the public object URL instead, and the bucket is private, so that URL
// played nowhere. Reading the key back out of such a URL lets those rows play like any other.

const S3_HOST = /^[^.]+\.s3[.-]([a-z0-9-]+\.)?amazonaws\.com$/i

/** The object key behind a stored recording reference: a bare key, or a URL on an S3 bucket host. */
export const s3KeyFromReference = (value: string): string => {
  if (!/^https?:\/\//i.test(value)) return value
  try {
    const url = new URL(value)
    if (!S3_HOST.test(url.hostname)) return value
    return decodeURIComponent(url.pathname.replace(/^\/+/, ''))
  } catch {
    return value
  }
}

/** Whether a reference is a key (or S3 URL) that must be signed, rather than a URL that plays as is. */
export const needsSigning = (value: string): boolean =>
  !/^https?:\/\//i.test(value) || s3KeyFromReference(value) !== value
